import { createAction } from "@reduxjs/toolkit";
import reduxStore from ".";
import { logoutUser } from "./slices/userSlice";

const cleanup = createAction("common/cleanup");

export const dispatchUserLogout = () => {
  reduxStore.dispatch(logoutUser());
  reduxStore.dispatch(cleanup());
};
